export default {
  emptyFilterPlaceholder: 'All',
  resetButton: 'Reset filters',
};
